import { render, staticRenderFns } from "./IpcSectors.vue?vue&type=template&id=47309d2e&"
import script from "./IpcSectors.vue?vue&type=script&lang=js&"
export * from "./IpcSectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47309d2e')) {
      api.createRecord('47309d2e', component.options)
    } else {
      api.reload('47309d2e', component.options)
    }
    module.hot.accept("./IpcSectors.vue?vue&type=template&id=47309d2e&", function () {
      api.rerender('47309d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/ipc-sectors/IpcSectors.vue"
export default component.exports